export default {
  state: {
    clips: [],
    videos: []
  },
  mutations: {
    setClips(state, payload) {
      state.clips = payload;
    },
    setVideos(state, payload) {
      state.videos = payload;
    },
  },
};
